var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutMission1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_2488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4165 11.5H40.2499C40.789 11.4989 41.3104 11.692 41.7187 12.044C42.127 12.396 42.3949 12.8833 42.4732 13.4167L45.0032 28.405C45.0551 28.6805 45.046 28.964 44.9765 29.2355C44.9069 29.5071 44.7786 29.7601 44.6007 29.9767C44.4205 30.193 44.1948 30.367 43.9398 30.4863C43.6847 30.6055 43.4065 30.6671 43.1249 30.6667H2.87488C2.5933 30.6671 2.31508 30.6055 2.06 30.4863C1.80492 30.367 1.57925 30.193 1.39904 29.9767C1.22111 29.7601 1.09284 29.5071 1.0233 29.2355C0.953756 28.964 0.944623 28.6805 0.996544 28.405L3.52654 13.4167C3.60487 12.8833 3.87272 12.396 4.28103 12.044C4.68934 11.692 5.21079 11.4989 5.74988 11.5H9.58321",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.875 35.4584H43.125",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7915 40.25H41.2082",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70825 45.0417H39.2916",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.674 1.05419C22.8575 0.959178 23.0682 0.930176 23.2706 0.972053C23.473 1.01393 23.6548 1.12414 23.7856 1.28419C23.9235 1.44316 24.0087 1.64103 24.0293 1.85047C24.0499 2.05991 24.0049 2.27057 23.9006 2.45336C23.1586 3.73552 22.8686 5.22972 23.0771 6.69637C23.2857 8.16302 23.9806 9.51717 25.0506 10.5417C25.8891 9.68247 26.5015 8.62884 26.8331 7.47503C26.8737 7.33126 26.9481 7.19925 27.0499 7.08996C27.1518 6.98068 27.2783 6.89727 27.4188 6.84667C27.5594 6.79606 27.71 6.77972 27.8581 6.799C28.0063 6.81829 28.1477 6.87263 28.2706 6.95753C29.6192 7.93949 30.714 9.22909 31.4641 10.7192C32.2141 12.2093 32.5978 13.8569 32.5831 15.525C32.6086 16.8088 32.3808 18.0849 31.9129 19.2806C31.445 20.4763 30.7461 21.5681 29.8562 22.4937C28.9662 23.4192 27.9027 24.1604 26.7262 24.6748C25.5498 25.1892 24.2835 25.4668 22.9998 25.4917C21.7161 25.4668 20.4498 25.1892 19.2734 24.6748C18.0969 24.1604 17.0334 23.4192 16.1434 22.4937C15.2535 21.5681 14.5546 20.4763 14.0867 19.2806C13.6188 18.0849 13.391 16.8088 13.4165 15.525C13.4539 12.489 14.341 9.52425 15.9772 6.96663C17.6134 4.40901 19.9333 2.36082 22.674 1.05419Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47241 19.8955L9.58325 11.5197",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5415 30.6667L2.22314 21.4092",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5273 19.8955L36.4165 11.5197",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4583 30.6667L43.7766 21.4092",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_2488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMission1);
export default __webpack_public_path__ + "static/media/aboutMission1.774fe89414c2dcbf16071d9cd6b7c7f0.svg";
export { ForwardRef as ReactComponent };